<template>
  <div class="weed" :class="unit.template.type" v-if="unit.template.categories.includes('weed')"></div>
  <div class="unit"
    v-touch:tap="touched"
    v-touch:longtap="touched"
    v-touch:touchhold="touched"
    v-touch:swipe="touched"
    v-touch:start="touched"
    v-touch:end="touched"
    v-touch:moving="touched"
    v-else>
    <unit-image
      class="unit-image"
      v-for="season in seasons"
      :class="{ alive: unit.isAlive(), dead: unit.isDead(), cut: unit.isCut(), show: season === 'default' || currentSeason === season }"
      :unitType="unit.template.type"
      :season="season"
      :key="imageKey + '-' + season"
      :style="{left: `${unit.id % 80 + 10}%`}"
    />
    <div class="unit-info" v-if="infoShowing">{{unit.template.name}}</div>
  </div>
</template>

<script>
import UnitImage from '@/components/game/UnitImage';

export default {
  props: {
    unit: Object,
  },
  components: {
    'unit-image': UnitImage,
  },
  data() {
    return {
      infoShowing: false,
    };
  },
  computed: {
    seasons() {
      return ['spring', 'summer', 'autumn', 'winter'];
    },
    currentSeason() {
      return this.$store.state.game.virtualTime.season;
    },
    imageKey() {
      return `unit-image-${this.unit.vueId}`;
    },
  },
  methods: {
    showInfo() {
      this.infoShowing = true;

      setTimeout(() => {
        this.infoShowing = false;
      }, 10000);
    },
    touched() {
      if (this.$store.state.userActionMode === 'cut') {
        const treeValue = this.unit.cut();
        this.$store.state.game.assetManager.addGold(treeValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.unit {
  .unit-image {
    z-index: 5;
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
    transition: opacity 1s, bottom 1s;
    animation: fadeIn 1s;
    opacity: 0;

    &.show {
      opacity: 1;
    }

    &.dead {
      opacity: 0 !important;
      bottom: -20px;
    }

    &.cut {
      opacity: 0 !important;
      bottom: 20px;
    }
  }

  .unit-info {
    position: absolute;
    top: -90px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    white-space: nowrap;
    font-size: 0.7rem;
    z-index: 999;
    background: #fff;
    padding: 0.2em 0.5em;
    border-radius: 5px;
    box-shadow: 0 2px 10px 0 rgba(#000, 0.1);
  }
}
.weed {
  width: 100%;
  height: 2px;
  margin-bottom: 9px;
  &.weed1s {
    background: #005000;
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/Unit.vue